import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as React from 'react';

var bindRefs = function bindRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (el) {
    return refs.forEach(function (ref) {
      if (typeof ref === "function") ref(el);else if (ref) ref.current = el;
    });
  };
};
function chainHandlers() {
  for (var _len2 = arguments.length, callbacks = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    callbacks[_key2] = arguments[_key2];
  }
  return function () {
    for (var _i = 0, _callbacks = callbacks; _i < _callbacks.length; _i++) {
      var callback = _callbacks[_i];
      if (typeof callback === "function") {
        callback.apply(void 0, arguments);
      }
    }
  };
}
function mergeProps() {
  var result = {};
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  for (var _i2 = 0, _args = args; _i2 < _args.length; _i2++) {
    var props = _args[_i2];
    for (var key in result) {
      if (/^on[A-Z]/.test(key) && typeof result[key] === "function" && typeof props[key] === "function") {
        result[key] = chainHandlers(result[key], props[key]);
      } else if (key === "ref") {
        result[key] = bindRefs(result[key], props[key]);
      } else if (key === "style") {
        result[key] = _objectSpread(_objectSpread({}, result[key]), props[key] ? props[key] : {});
      } else {
        result[key] = props[key] !== void 0 ? props[key] : result[key];
      }
    }
    for (var _key4 in props) {
      if (result[_key4] === void 0) {
        result[_key4] = props[_key4];
      }
    }
  }
  return result;
}
function isMantleComponentOfType(c, Component) {
  if ( /*#__PURE__*/React.isValidElement(c) && typeof c !== "string" && "type" in c && typeof c.type !== "string" && c.type.__TYPE === Component.__TYPE) {
    return true;
  }
  return false;
}
function isOnlyChildClonable(children) {
  return /*#__PURE__*/React.isValidElement(children) && React.Children.only(children) && typeof children !== "string";
}
function onlyText(children) {
  if (!(children instanceof Array) && ! /*#__PURE__*/React.isValidElement(children)) {
    return childToString(children);
  }
  return React.Children.toArray(children).reduce(function (text, child) {
    var newText = "";
    if ( /*#__PURE__*/React.isValidElement(child) && hasChildren(child)) {
      newText = onlyText(child.props.children);
    } else if ( /*#__PURE__*/React.isValidElement(child) && !hasChildren(child)) {
      newText = "";
    } else {
      newText = childToString(child);
    }
    return text.concat(newText);
  }, "");
}
function hasChildren(element) {
  return /*#__PURE__*/React.isValidElement(element) && Boolean(element.props.children);
}
function childToString(child) {
  if (typeof child === "undefined" || child === null || typeof child === "boolean") return "";
  if (JSON.stringify(child) === "{}") return "";
  return child.toString();
}
function usePrevious(value) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export { bindRefs, isMantleComponentOfType, isOnlyChildClonable, mergeProps, onlyText, usePrevious };
